(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomSectionTypeAttributeDeleteController',CustomSectionTypeAttributeDeleteController);

    CustomSectionTypeAttributeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomSectionTypeAttribute'];

    function CustomSectionTypeAttributeDeleteController($uibModalInstance, entity, CustomSectionTypeAttribute) {
        var vm = this;

        vm.customSectionTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomSectionTypeAttribute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
